import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SdThemeComponent } from '../abstract/theme/theme.component';

@Component({
  selector: 'sd-brand-bar',
  templateUrl: './brand-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SdBrandBarComponent extends SdThemeComponent {
  @Input()
  isVerticalBar: boolean;
}
